// RMA commodity code -> crop name. ONE dictionary, imported by BOTH carrier
// pipelines and by the checkers. Do not re-declare it anywhere.
//
// Why this is a module and not a constant in each sync: on 2026-08-12 onions
// were added to api/_rma-price.js DEFAULT_COMMODITIES and to m13-sync's copy of
// this map, and NAU's copy never got the entry. Both syncs fall back to the RAW
// commodity code when the lookup misses, so NAU would have stored a crop named
// "0013" — a code no price lookup, no crop filter and no grower can read — while
// every row count stayed healthy. That is the same drift this repo has already
// recorded three times over (three news handlers, two guarantee engines, three
// normFarmerName copies): a rule defined twice is a rule that drifts once.
//
// Every entry is sourced from RMA's own document numbering, never a guess at the
// name. Add a code here WITH its source, or leave it out and let it render raw.
//
// 0034 = PEACHES (RMA Peach Crop Provisions 23-0034), measured in bushels — NOT
// sweet corn. Was mislabeled "SWEET CORN", surfacing peaches on Susquehanna
// Orchards' apple policy. Real Fresh Market Sweet Corn is 0044. Fixed 2026-06-22.
//
// 0013 = ONIONS. The price feed has pulled onions since 2026-08-12 and 330 CY2026
// rows sit in rma_prices with the right numbers (NY t170 $25.80 / t180 $19.10 /
// t190 $15.60, confirmed against CY Farms' own SOI) — but the map never got the
// entry, so NOTHING could turn commodity 0013 into a crop name and all three
// coverages ($565,379) still rendered a guarantee of "—". Pulling a price and
// being able to USE it are two different things; check-data's
// commodity-map-complete asserts the two lists agree so this cannot half-land
// again. Code sourced like peaches, from RMA's own document numbering: Onion Crop
// Provisions 17-0013 / 11-0013, and it appears as Onions "0013" in RMA's P11
// Enhanced Appendix III.
//
// NOTE: 0021 below is suspect — likely Cotton, not Barley (0091) — but no policy
// in this NY/PA/OH/MI/IN/MD book uses it, so it is left unverified rather than
// corrected on a hunch.
const RMA_CROPS = {
  "0011":"WHEAT","0013":"ONIONS","0016":"OATS","0021":"BARLEY","0034":"PEACHES","0041":"CORN","0046":"PROCESSING BEANS",
  "0047":"DRY BEANS","0051":"GRAIN SORGHUM","0053":"GRAPES","0054":"APPLES",
  "0072":"CABBAGE","0081":"SOYBEANS",
  "0084":"POTATOES","0088":"PRF","0091":"BARLEY","0158":"TRITICALE",
  "0801":"FEEDER CATTLE","0802":"FED CATTLE","0815":"DRP","0830":"MARGIN PROTECTION",
};

module.exports = { RMA_CROPS };
